import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  connect() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => {
      const tooltipInstance = new bootstrap.Tooltip(tooltipTriggerEl);

      tooltipTriggerEl.addEventListener('click', () => {
        tooltipInstance.hide();
      });

      return tooltipInstance;
    });
  }
}